module.exports = __webpack_public_path__ + "static/img/img26.d820615.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ychy/img26.png
// module id = tKKA
// module chunks = 1